var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Preview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998594,1.78523862e-13 C18.5244375,1.78523862e-13 23.6330156,6.88823438 23.8474219,7.18153125 C24.0507656,7.4595 24.0507656,7.83717188 23.8474219,8.115375 C23.6330156,8.40839063 18.5244375,15.2966719 11.9998594,15.2966719 C5.47528125,15.2966719 0.36646875,8.4084375 0.152296875,8.11514063 C-0.050765625,7.83689063 -0.050765625,7.4595 0.152296875,7.18125 C0.36646875,6.88823438 5.47528125,1.78523862e-13 11.9998594,1.78523862e-13 Z M11.9998594,1.58240625 C7.1835,1.58240625 3.02967188,6.151875 1.7990625,7.64779688 C3.03126563,9.14240625 7.1938125,13.7142656 11.9998594,13.7142656 C16.8162188,13.7142656 20.9700469,9.14475 22.2006563,7.648875 C20.9679375,6.15346875 16.8056719,1.58240625 11.9998594,1.58240625 Z M11.9998594,2.90109375 C14.6174531,2.90109375 16.747125,5.03076562 16.747125,7.64835937 C16.747125,10.2659531 14.6174531,12.395625 11.9998594,12.395625 C9.38226562,12.395625 7.25259375,10.2659531 7.25259375,7.64835937 C7.25259375,5.03076562 9.38226562,2.90109375 11.9998594,2.90109375 Z M11.9998594,4.48354687 C10.25475,4.48354687 8.83504687,5.90325 8.83504687,7.64835937 C8.83504687,9.39346875 10.2547031,10.8131719 11.9998594,10.8131719 C13.7450156,10.8131719 15.1646719,9.39346875 15.1646719,7.64835937 C15.1646719,5.90325 13.7449687,4.48354687 11.9998594,4.48354687 Z",
    id: "path-123"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-123",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-eye",
    transform: "translate(0.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(0.000000, 4.039141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-1232",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-123"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-123"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-/-Default",
    mask: "url(#mask-1232)",
    fill: "#444657"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -4.039141)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.f4044c6549d0a0197edd145713f42553.svg";
export { ForwardRef as ReactComponent };